const divModalAction = {
  fileError: 'Aguarde todos os arquivos subirem'
};

export default divModalAction;
